import { useEffect, useState } from "react";
import { AppListing } from "../../components/appListing";
import moment from "moment";
import { useGetImmunizationsQuery } from "../../redux/service/immunizations_service";
import { LoadingData } from "../../utils/common_lib";

export const Immunizations = ({ header = true }) => {
  const [immunizationsList, setImmunizationsList] = useState([]);

  moment.updateLocale("fr", {
    invalidDate: "-",
  });

  const cols = [
    {
      title: "Vaccine",
      key: "immunization_vaccine_title",
      colClass: "text-blue-500",
      getData: (item) => {
        if (item?.type != "recorded" && item?.type != "refused") {
          return item?.immunization_vaccine_title;
        }
        if (item.type == "recorded" || item.type == "refused") {
          if (item?.immunization_vaccine_title == "") {
            return item?.immunization_category_title;
          } else {
            return item?.immunization_vaccine_title;
          }
        }
      },
    },
    {
      title: "Dose",
      getData: (item) => (item?.dose ? item?.dose + " " + item?.unit : "-"),
    },
    { title: "Ordered By", key: "ordered_by_name" },
    {
      title: "Administered By",
      key: "administered_by_name",
      alt_key: "record_administered_by",
    },
    {
      title: "Administration Date",
      getData: (item) => moment(item?.datetime).format("MM/DD/YYYY"),
    },
    { title: "Lot No.", key: "lot_number" },
    { title: "Status", key: "type" },
  ];

  const { data, refetch, isFetching } = useGetImmunizationsQuery();

  useEffect(() => {
    if (data?.data && data?.data.length) {
      setImmunizationsList(data?.data);
    }
  }, [data]);

  const getColData = (item, col) => {
    if (typeof col.getData == "function") {
      return col.getData(item);
    }
    // if(col.type == 'date'){
    //   return this.Common.formateDate(item[col.key], col.format || "MM/DD/YYYY hh:mm A");
    // }
    if (col.type == "amount") {
      return `$${item[col.key] || "0"}`;
    }
    return item[col.key] || item[col.alt_key] || "";
  };

  return (
    <>
      {header && (
        <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Immunizations
            </h3>
          </div>
          <div className=" flex-shrink-0">
            <button
              type="button"
              onClick={refetch}
              className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Reload
            </button>
          </div>
        </div>
      )}
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <>
          <div className="flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-4 lg:-mx-6">
              <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-6">
                <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        {cols.map((col, colIndex) => {
                          return (
                            <>
                              <th
                                key={`col_title_${colIndex}`}
                                scope="col"
                                className="py-3.5 px-3 text-left text-sm text-slate-500"
                              >
                                {col.skipColTitle ? "" : col.title}
                              </th>
                            </>
                          );
                        })}
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-200 bg-white">
                      {isFetching ? (
                        <tr>
                          <td colSpan={cols.length}>
                            <LoadingData />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {immunizationsList?.map((item, itemIndex) => {
                            return (
                              <>
                                <tr>
                                  {cols?.map((col, colIndex) => {
                                    return (
                                      <>
                                        {col.title == "Vaccine" ||
                                        col.title == "Status" ? (
                                          <td className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900 capitalize">
                                            <span
                                              title={col.title}
                                              onClick={() => {
                                                if (
                                                  typeof col.onClick ===
                                                  "function"
                                                ) {
                                                  col.onClick(item, col);
                                                }
                                              }}
                                              class={`${
                                                col.onClick
                                                  ? "cursor-pointer text-primary"
                                                  : ""
                                              } 
                                              ${
                                                col?.colClass && col?.colClass
                                              }`}
                                            >
                                              {getColData(item, col)}
                                            </span>
                                          </td>
                                        ) : item?.type == "administered" ||
                                          item?.type == "ordered" ||
                                          item?.type == "recorded" ? (
                                          <td className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900 ">
                                            <span
                                              title={col.title}
                                              onClick={() => {
                                                if (
                                                  typeof col.onClick ===
                                                  "function"
                                                ) {
                                                  col.onClick(item, col);
                                                }
                                              }}
                                              class={`${
                                                col.onClick
                                                  ? "cursor-pointer text-primary"
                                                  : ""
                                              } 
                                              ${
                                                col?.colClass && col?.colClass
                                              }`}
                                            >
                                              {getColData(item, col)}
                                            </span>
                                          </td>
                                        ) : (
                                          <>
                                            {col.title == "Dose" && (
                                              <td
                                                className="whitespace-nowrap py-4 px-3 text-sm font-medium text-red-500 "
                                                colspan="2"
                                              >
                                                {item?.type == "refused" &&
                                                item?.datetime ? (
                                                  <span>
                                                    Date Refused:{" "}
                                                    {moment(
                                                      item?.datetime
                                                    ).format("MM/DD/YYYY")}
                                                  </span>
                                                ) : (
                                                  item?.type == "scheduled" && (
                                                    <span>
                                                      {item?.vaccine_display_string?.replace(
                                                        "~",
                                                        ""
                                                      )}
                                                    </span>
                                                  )
                                                )}
                                              </td>
                                            )}
                                            {col.title == "Administered By" && (
                                              <td
                                                className="whitespace-nowrap py-4 px-3 text-sm font-medium text-red-500 "
                                                colSpan="3"
                                              >
                                                {item?.type == "refused" &&
                                                item?.refusal_reason ? (
                                                  <span>
                                                    Reason Refused:{" "}
                                                    {item?.refusal_reason_title ||
                                                      item?.refusal_reason}
                                                  </span>
                                                ) : (
                                                  item?.type == "scheduled" &&
                                                  item?.scheduled_by_name !=
                                                    "" && (
                                                    <span>
                                                      Scheduled By:{" "}
                                                      {item?.scheduled_by_name}
                                                    </span>
                                                  )
                                                )}
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </>
                                    );
                                  })}
                                </tr>
                              </>
                            );
                          })}
                        </>
                      )}
                      {immunizationsList?.length === 0 && !isFetching && (
                        <div className="p-2">No record found.</div>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};
